export const resolveEyebrowTypographyVariant = (eyebrowStyle: string) => {
	if (eyebrowStyle === 'Promo') return 'bodyXLBook';
	return 'bodyLargeBook';
};

export const getEyebrowStyles = (eyebrowStyle: string) => {
	return {
		fontWeight: eyebrowStyle === 'Promo' ? 700 : 400,
		fontSize: { md: '1.125rem', xs: '1rem' },
	};
};

export const getBodyDocPropsVariant = (isSmallScreen: boolean, bodySize: string) => {
	if (isSmallScreen) return 'bodyMediumBook';
	if (bodySize === 'Medium') return 'bodyLargeBook';
	return 'bodyXLBook';
};
